/**
 * 精品服务组件
 * zxw
 * 2024-01-17
 */

import { Row, Col, Divider, ConfigProvider } from 'antd';

import {
    DeploymentUnitOutlined,
    CustomerServiceOutlined,
    AimOutlined,
    DatabaseOutlined,
} from '@ant-design/icons';


const Premium = () => {
    return <div className='premium'>
        <Row>
            <Col span={6} style={{ paddingRight: '5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><DeploymentUnitOutlined /></div>
                    <h2>项目运维服务</h2>
                    <p>根据客户需求定制服务级别协议，对企业组织内部信息系统进行日常维护和管理。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                </div>
            </Col>
            <Col span={6} style={{ padding: '0 5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><CustomerServiceOutlined /></div>
                    <h2>技术咨询服务</h2>
                    <p>为客户提供专业的信息技术咨询服务，帮助客户制定和实施信息化战略。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                </div>
            </Col>
            <Col span={6} style={{ padding: '0 5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><AimOutlined /></div>
                    <h2>系统集成服务</h2>
                    <p>根据客户需求设计、开发和实施定制化信息系统，实现信息化、智能化转型。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                </div>
            </Col>
            <Col span={6} style={{ paddingLeft: '5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><DatabaseOutlined /></div>
                    <h2>机房运维服务</h2>
                    <p>对机房数据中心设施、设备和运行软件进行管理、维护和监控。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                </div>
            </Col>
        </Row>
    </div>
}

export default Premium;